import axios, { AxiosResponse } from 'axios';
import { getAccessToken, getLob } from './authenticationService';
import { EnvironmentRegistry } from './registry/environmentRegistry';

export interface NewReportRequestBody {
  configName: string;
  params: Record<string, any>;
}

export interface NewReportResponse {
  data: any;
  status: string;
  message?: string;
}

export async function downloadNewReport(requestBody: NewReportRequestBody): Promise<Blob> {
  // Get the authorization token using the standard function
  const token = getAccessToken();
  
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    'X-Tenant-ID': getLob() || ''
  };
  
  // Add authorization header if token is available
  if (token) {
    // Add Bearer prefix ONLY if it's not already there
    headers['Authorization'] = token.startsWith('Bearer ') ? token : `Bearer ${token}`;
  }
  
  try {
    const response = await axios.post(
      "https://datastream-stg.salescode.ai/download?attachment=true",
      requestBody,
      {
        headers: headers,
        responseType: 'blob'
      }
    );
    
    return response.data;
  } catch (error: any) {
    // Handle blob error response properly
    if (error.response?.data instanceof Blob) {
      try {
        const errorText = await error.response.data.text();
        const errorData = JSON.parse(errorText);
        console.error("API Error:", errorData);
        throw new Error(errorData.error || 'API request failed');
      } catch (parseError) {
        console.error("Could not parse error response:", parseError);
        throw new Error('API request failed with unknown error');
      }
    } else {
      console.error("API Error:", error.response?.data || error.message);
      throw error;
    }
  }
}

export interface LiveReportDownloadRequest {
  reportName: string;
  filters?: {
    map: Record<string, string[]>;
  };
  dateRange?: {
    startDate: string;
    endDate: string;
  };
  format?: string;
}

export async function downloadLiveFilterReport(
  requestBody: LiveReportDownloadRequest
): Promise<AxiosResponse<Blob>> {
  const token = getAccessToken();

  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    'X-Tenant-ID': getLob() || ''
  };

  if (token) {
    headers['Authorization'] = token.startsWith('Bearer ') ? token : `Bearer ${token}`;
  }

  try {
    //     const baseUrl = EnvironmentRegistry.getDatastreamUrl();
    const env = EnvironmentRegistry.getEnvironment();
    let DATASTREAM_BASE_URL = '';
    if(env === 'prod'){
      DATASTREAM_BASE_URL = 'https://datastream.salescode.ai';
    }
    else if(env === 'demo'){
      DATASTREAM_BASE_URL = 'https://datastream-demo.salescode.ai';
    }
    else if(env === 'uat'){
      DATASTREAM_BASE_URL = 'https://datastream-uat.salescode.ai';
    }


    // const baseUrl = EnvironmentRegistry.getDatastreamUrl();
    const response = await axios.post<Blob>(
      `${DATASTREAM_BASE_URL}/rpt-generic/download`,
      requestBody,
      {
        headers,
        responseType: 'blob'
      }
    );

    return response;
  } catch (error: any) {
    if (error.response?.data instanceof Blob) {
      try {
        const errorText = await error.response.data.text();
        const errorData = JSON.parse(errorText);
        console.error("API Error:", errorData);
        throw new Error(errorData.error || 'API request failed');
      } catch (parseError) {
        console.error("Could not parse error response:", parseError);
        throw new Error('API request failed with unknown error');
      }
    } else {
      console.error("API Error:", error.response?.data || error.message);
      throw error;
    }
  }
}
